var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container',[_c('div',{staticClass:"white--text text-center"},[_c('h2',{staticClass:"mb-5"},[_vm._v("Coming Soon:")]),_c('h1',[_vm._v("Sony's New Rebate Center")]),_c('p',{staticClass:"mb-5"}),_c('p',{staticClass:"mb-0"},[_vm._v("Please check back soon")]),_c('p',[_vm._v("Thank you")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }